

































import Component from 'vue-class-component'
import DoughnutChartWidget from '@/components/widgets/DoughnutChartWidget.vue'
import {DistributionChartSection} from '@/models/LobbyDataResponse.model'
import LoginAuditChartSectionComponent
    from '@/components/dashboard/lobby/sections/LoginAuditChartSection.component.vue'
import {Getter} from 'vuex-class'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import BaseComponent from '@/components/base/BaseComponent'

@Component({
    components: {
        DoughnutChartWidget,
        LoginAuditChartSectionComponent
    }
})
export default class DistributionChartSectionComponent extends BaseComponent {

    private chartLegendId: string = 'distribution-chart-legend'
    private window: any = window

    @Getter('distributionChartSection', StoreNamespace.LOBBY) distributionChartSection!: DistributionChartSection;

    dataExists(): boolean {
        return this.distributionChartSection
            && this.distributionChartSection.distributionChart
            && this.distributionChartSection.distributionChart.datasets.length > 0
            && this.distributionChartSection.distributionChart.datasets[0].data
            && this.distributionChartSection.distributionChart.datasets[0].data.length > 0;
    }
}
